import { FETCH_CONTACT_OPTIONS } from './constants'
import { take, call, put, select } from 'redux-saga/effects'
import { apiFetchContactOptions } from './services'
import { fetchContactOptions } from './actions'
import languages from '../../constants/languages'

function* fetchContactOptionsWorker() {
  const state = yield select()
  const preSaleFlag = state.devicebits.preSaleFlag
  const language = languages[state.devicebits.language]
  const customer = state.devicebits.customer
  const response = yield call(
    apiFetchContactOptions,
    preSaleFlag,
    language,
    customer
  )

  if (Array.isArray(response)) {
    yield put(fetchContactOptions.success(response))
  }
}

export default function* watcher() {
  while (true) {
    yield take(FETCH_CONTACT_OPTIONS.REQUEST)
    yield call(fetchContactOptionsWorker)
  }
}



// WEBPACK FOOTER //
// ./src/containers/ContactUsModal/sagas.js